import React, { useState, useRef, useEffect } from 'react';
import Header from '../DashboardMain/Header';
// import Sidebar from '../DashboardMain/Sidebar';
import { Outlet, Link } from "react-router-dom";

const LayoutMain = () => {

  return (
    <div className="container-fluid p-0">
      <Header />
      <div className="d-flex">
        <div
          className="bg-dark text-white p-3"
          style={{ width: "70px"}}>
          {/* <Sidebar /> */}
        </div>
        <div className="flex-grow-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LayoutMain;